import React, { useState, useCallback } from 'react'

const initialState = {
  name: process.env.REACT_APP_NAME,
  subtitle: '',
  version: process.env.REACT_APP_VERSION
}

export const AppContext = React.createContext(initialState)

export const AppProvider = ({ children }) => {
  const [redirectUrl, setRedirectUrl] = useState('')
  const [pageTitle, setPageTitle] = useState(initialState.name)
  const [pageSubtitle, setPageSubtitle] = useState(initialState.subtitle)
  const [isHeaderVisible, setHeaderVisibility] = useState(true)
  const [lengthUnit, setLengthUnit] = useState('m')
  const [weightUnit, setWeightUnit] = useState('kg')

  const convertToCurrentLengthUnit = useCallback((value, unit) => {
    if (unit === lengthUnit) {
      return value
    }
    else if (lengthUnit === 'ft') {
      return value*3.281
    }
    return value/3.281
  }, [lengthUnit])

  const convertToCurrentWeightUnit = useCallback((value, unit) => {
    if (unit === weightUnit) {
      return value
    }
    else if (weightUnit === 'lb') {
      return value*2.205
    }
    return value/2.205
  }, [weightUnit])

  return <AppContext.Provider value={{
    ...initialState,
    redirectUrl,
    pageTitle,
    pageSubtitle,
    isHeaderVisible,
    lengthUnit,
    weightUnit,
    convertToCurrentLengthUnit,
    convertToCurrentWeightUnit,
    setLengthUnit,
    setWeightUnit,
    setRedirectUrl,
    setPageTitle,
    setPageSubtitle,
    setHeaderVisibility
  }}>
    {children}
  </AppContext.Provider>
}